var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('aside',{staticClass:"sidebar"},[_c('div',_vm._l((_vm.menuItems),function(item){return (!item.hidden)?_c('router-link',{key:item.label,staticClass:"menu-item",attrs:{"to":item.path,"tag":"div"}},[_vm._v(_vm._s(item.label))]):_vm._e()}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }